import { Link } from 'react-router-dom';

import { useCartStore } from '@lib/store/cartStore';
import { ROUTES } from '@lib/routes';

export function CartIcon(): JSX.Element {
  const itemCount = useCartStore((state) => state.getItemCount());

  return (
    <Link
      to={ROUTES.CUSTOMER.CART}
      className="relative inline-flex items-center p-2 text-primary hover:text-site-accent active:text-site-accent/80 transition-all duration-200 hover:scale-110 active:scale-95"
      aria-label={`Shopping cart with ${itemCount} items`}
    >
      <svg
        className="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
        />
      </svg>
      {itemCount > 0 && (
        <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white transform translate-x-1/2 -translate-y-1/2 bg-red-600 rounded-full">
          {itemCount > 99 ? '99+' : itemCount}
        </span>
      )}
    </Link>
  );
}

